//官网渠道： http://ishare.phfund.com.cn/landingpage?cm_mmc=web-_-home-_-banner1-_-<鹏华官网 Cookie ID>
//短信渠道： http://ishare.phfund.com.cn/landingpage?cm_mmc=sms-_-campaign1-_-0918-_-<鹏华 客户编号>
//邮件渠道： http://ishare.phfund.com.cn/landingpage?cm_mmc=edm-_-campaign1-_-0918-_-<鹏华 客户编号>
//微信渠道： http://ishare.phfund.com.cn/landingpage?cm_mmc=wechat-_-campaign1-_-0918-_-<鹏华 openid>

/**
 * 调用IBM的页面嵌码方法
 * example:implantPage('钱包推广_下载页','钱包推广')
 * @param pageId
 * @param categoryId
 * @returns
 */
function implantPage(pageId,categoryId){
	var pageURL = window.location.href;//当前页面URL的全路径
//	pageURL = 'http://ishare.phfund.com.cn/landingpage?cm_mmc=web-_-home-_-banner1-_-cookieId007';
	if(!isNull(pageURL)){
		var chanelName = loadValue('chanelName',false);
		var transParam = loadValue('transParam',false);
		if(!isNull(chanelName) && !isNull(transParam)){
			choosePageFun(pageId,categoryId,chanelName,transParam);
		}else{
			pageURL = pageURL.replace(/\s+/g,"");
			var index = pageURL.indexOf('cm_mmc=');
			if(Number(index) > -1){
				var params = pageURL.substring(index+7);
//				var endIndex = pageURL.indexOf('&',index);
//				if(endIndex > -1){
//					params = unescape(pageURL.substring(index+7,endIndex));
//				}else{
//					params = unescape(pageURL.substring(index+7));
//				}
				saveValue('cmParams',params,false);
				var index2 = params.indexOf('-_-');
				if(Number(index2) > -1){
					var parArr = params.split('-_-');
					var len = parArr.length;
					var chanelName = parArr[0];
					var transParam = parArr[len-1];
					saveValue('chanelName',chanelName,false);
					saveValue('transParam',transParam,false);
					choosePageFun(pageId,categoryId,chanelName,transParam);
				}else{
					choosePageFun(pageId,categoryId,'','');
				}
			}else{
				choosePageFun(pageId,categoryId,'','');
			}
		}
	}
}
/**
 * 调用IBM的按钮嵌码方法
 * example:implantBtn('钱包推广_活动页_Android下载','钱包推广','钱包推广_下载页','APK')
 * @param elementId		按钮点击功能简述
 * @param categoryId
 * @param pageId
 * @param sysFlag  		APK或IOS
 */
function implantBtn(elementId,categoryId,pageId,sysFlag){
	var pageURL = window.location.href;//当前页面URL的全路径
//	pageURL = 'http://ishare.phfund.com.cn/landingpage?cm_mmc=web-_-home-_-banner1-_-cookieId007';
	if(!isNull(pageURL)){
		var chanelName = loadValue('chanelName',false);
		var transParam = loadValue('transParam',false);
		if(!isNull(chanelName) && !isNull(transParam)){
			chooseBtnFun(elementId,categoryId,pageId,sysFlag,chanelName,transParam);
		}else{
			pageURL = pageURL.replace(/\s+/g,"");
			var index = pageURL.indexOf('cm_mmc=');
			if(Number(index) > -1){
				var params = pageURL.substring(index+7);
//				var endIndex = pageURL.indexOf('&',index);
//				if(endIndex > -1){
//					params = unescape(pageURL.substring(index+7,endIndex));
//				}else{
//					params = unescape(pageURL.substring(index+7));
//				}
				var index2 = params.indexOf('-_-');
				if(Number(index2) > -1){
					var parArr = params.split('-_-');
					var len = parArr.length;
					var chanelName = parArr[0];
					var transParam = parArr[len-1];
					saveValue('chanelName',chanelName,false);
					saveValue('transParam',transParam,false);
					chooseBtnFun(elementId,categoryId,pageId,sysFlag,chanelName,transParam);
				}else{
					chooseBtnFun(elementId,categoryId,pageId,sysFlag,'','');
				}
			}else{
				chooseBtnFun(elementId,categoryId,pageId,sysFlag,'','');
			}
		}
	}
}
/**
 * 根据渠道号选择调用页面嵌码方法
 * values:  鹏华官网CookieID	  客户编号  鹏华微信OPENID	 版本号	系统(默认H5)
 * callFun:cmCreatePageviewTag("PC_A+推广_活动页", PC_A+推广", null, null,"02cb062ef19107df5d2e4"-_--_--_--_-"H5")
 * @param pageId		pageId
 * @param categoryId	categoryId
 * @param chanelName	渠道名
 * @param transParam	传递的参数
 */
function choosePageFun(pageId,categoryId,chanelName,transParam){
	if(chanelName.indexOf('_vid') > -1){
		cmCreatePageviewTag(pageId, categoryId, null, null,transParam+'-_--_--_--_-H5');
	}else if(chanelName.indexOf('_cno') > -1){
		cmCreatePageviewTag(pageId, categoryId, null, null,'-_-'+transParam+'-_--_--_-H5');
	}else if(chanelName.indexOf('_ph') > -1 || chanelName.indexOf('_pyh') > -1){
		cmCreatePageviewTag(pageId, categoryId, null, null,'-_--_-'+transParam+'-_--_-H5');
	}else{
		cmCreatePageviewTag(pageId, categoryId, null, null,'-_--_--_--_-H5');
	}
}

/**
 * 根据渠道号选择调用按钮嵌码方法
 * values:  PageID	  鹏华官网CookieID	  客户编号 	鹏华微信OPENID		系统
 * callFun:cmCreateElementTag("钱包推广_活动页_Android下载","钱包推广","钱包推广_活动页"-_-"02cb062ef19107df5d2e4"-_--_--_-"APK")
 * @param elementId		按钮点击功能简述
 * @param categoryId	categoryId
 * @param pageId		pageId
 * @param sysFlag		APK或IOS
 * @param chanelName	渠道名
 * @param transParam	传递的参数
 */
function chooseBtnFun(elementId,categoryId,pageId,sysFlag,chanelName,transParam){
	if(chanelName.indexOf('_vid') > -1){
		cmCreateElementTag(elementId, categoryId, pageId+'-_-'+transParam+'-_--_--_-'+sysFlag);
		Countly.add_event({"key":"download_click", "count":1, "segmentation":{"elementid":elementId, "cookieid":transParam, "custno":"", "openid":""}});
	}else if(chanelName.indexOf('_cno') > -1){
		cmCreateElementTag(elementId, categoryId, pageId+'-_--_-'+transParam+'-_--_-'+sysFlag);
		Countly.add_event({"key":"download_click", "count":1, "segmentation":{"elementid":elementId, "cookieid":"", "custno":transParam, "openid":""}});
	}else if(chanelName.indexOf('_ph') > -1 || chanelName.indexOf('_pyh') > -1){
		cmCreateElementTag(elementId, categoryId, pageId+'-_--_--_-'+transParam+'-_-'+sysFlag);
		Countly.add_event({"key":"download_click", "count":1, "segmentation":{"elementid":elementId, "cookieid":"", "custno":"", "openid":transParam}});
	}else{
		cmCreateElementTag(elementId, categoryId, pageId+'-_--_--_--_-'+sysFlag);
		Countly.add_event({"key":"download_click", "count":1, "segmentation":{"elementid":"", "cookieid":"", "custno":"", "openid":""}});
	}
}
/**
 * 获取二维码的地址
 * @returns {String}
 */
function getImgPath(){
	var result;
	var pageURL = window.location.href;//当前页面URL的全路径
	pageURL = pageURL.replace(/\s+/g,"");
	var pArr = pageURL.split('/');
	var baseGetURL = pArr[0]+"//"+pArr[2]+"/"+pArr[3]+"/"; // qrcode?cm_mmc=123
//	baseGetURL = '';
	var index = pageURL.indexOf('cm_mmc=');
	if(Number(index) > -1){
		result = baseGetURL+'qrcode?'+pageURL.substring(index);
	}else{
		result = baseGetURL+'qrcode';
		var cmParams = loadValue('cmParams',false);
		if(!isNull(cmParams)){
			result += '?cm_mmc='+cmParams;
		}
	}
	return result;
}

/**
 * 判断数值是否为空
 * @param str	判断的值
 * @returns
 */
function isNull(str) {
	if (str == "null" || str == null || typeof (str) == "undefined" || str == "undefined" || str == "") {
		return true;
	}
	return false;
}

/**
 * 保存值
 * @param key
 * @param value
 * @param bFlag true-本地，false-session 
 * @returns
 */
function saveValue(key, value, bFlag){
// 	if(bFlag==false){
// 		//程序退出即消失
// //		sessionStorage.setItem(key,value);
// 		//存cookie
// 		setCookie(key,value);
// 	}else if(bFlag==true){
// 		//保存本地
// //		sessionStorage.setItem(key,value);
// 		//存cookie
// 		setCookie(key,value);
// 	}

	localStorage.setItem(key, value);
}

/**
 * 获取值
 * @param key
 * @param value
 * @param bFlag true-本地，false-session 
 * @returns
 */
function loadValue(key, bFlag){
// 	if(bFlag==false){
// //		return sessionStorage.getItem(key);
// 		return getCookie(key);
// 	}else if(bFlag==true){
// //		return sessionStorage.getItem(key);
// 		return getCookie(key);
// 	}
	return localStorage.getItem(key);
}

/**
 * 从cookie中获取某个值
 * @param c_name	key
 * @returns			存在返回value,不存在返回""
 */
function getCookie(c_name){
	if (document.cookie.length>0){
	  c_start=document.cookie.indexOf(c_name + "=");
	  if (c_start!=-1){ 
	    c_start=c_start + c_name.length+1 ;
	    c_end=document.cookie.indexOf("|_|",c_start);
	    if (c_end==-1) c_end=document.cookie.length;
	    return unescape(document.cookie.substring(c_start,c_end));
	  } 
	}
	return ""
}

/**
 * 向cookie中存信息
 * @param c_name	key
 * @param value		value
 * @param expiredays	cookie失效时间(天数,如果设置了该值,cookie存放在硬盘中,只有超时了才失效,不设置此值,则为会话cookie,关闭浏览器便失效)
 */
function setCookie(c_name,value,expiredays){
	var exdate=new Date();
	exdate.setDate(exdate.getDate()+expiredays);
	document.cookie += "|_|"+c_name+ "=" +escape(value)+
	((expiredays==null) ? "" : "|_|expires="+exdate.toGMTString())+'|_|';
}

/**
 * 检查cookie中是否存在存有某个值
 * @param key	key
 * @returns {Boolean}	true表示存在,false表示不存在
 */
function checkCookie(key){
	var value=getCookie(key);
	if (value!=null && value!=""){
		return true;
	}else{
		return false;
	}
}
